import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import MainLayout from 'src/components/MainLayout';
import { AppConfig } from 'src/config/AppConfig';
import Swal from 'sweetalert2';
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg";
import LoadingGif from 'src/components/layout/Loader';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux/hooks';
import { startLoading, stopLoading } from 'src/store/loading/loadingSlice';
import edit from "../../../../assets/img/icons/icons8-edit.svg"
import Checkbox from 'src/components/layout/Checkbox';
interface InitialValuesType {

   _id: string;
   phone: string;
   is_otp_verified: boolean;
   is_user_details_completed: boolean;
   is_user_verified: boolean;
   country: string;
   state: string;
   city: string;
   lat: number;
   long: number;
   pin_code: string;
   dial_code: string,
   street: string;
   landmark: string;
   name: string;
   createdAt: string;
   otp: string;
   profile_pic: File | null;
}
const getUserById = async (token: string, id: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/user/${id}`, {
      headers: {
         "x-access-token": token
      }
   });
}

function UserEditPage() {
   const initialValues: InitialValuesType = {
      _id: "",
      phone: "",
      is_otp_verified: false,
      is_user_details_completed: false,
      is_user_verified: false,
      country: "",
      state: "",
      city: "",
      lat: 0,
      long: 0,
      pin_code: "",
      createdAt: '',
      street: "",
      otp: "",
      dial_code: "",
      landmark: "",
      name: "",
      profile_pic: null
   };
   const { id } = useParams();
   const Token = Cookies.get("token");
   const [selectedUser, setSelectedUser] = useState(initialValues);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const navigate = useNavigate();

   useEffect(() => {
      getUserById(Token as string, id as string).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {

            // setSelectedUser(res?.data?.data);
            setSelectedUser({
               ...selectedUser,
               _id: res?.data?.data?._id,
               is_otp_verified: res?.data?.data?.is_otp_verified,
               is_user_details_completed: res?.data?.data?.is_user_details_completed,
               is_user_verified: res?.data?.data?.is_user_verified,
               phone: res?.data?.data?.phone,
               otp: res?.data?.data?.otp,
               country: res?.data?.data?.address?.country,
               state: res?.data?.data?.address?.state,
               city: res?.data?.data?.address?.city,
               lat: res?.data?.data?.address?.lat,
               long: res?.data?.data?.address?.long,
               pin_code: res?.data?.data?.address?.pin_code,
               landmark: res?.data?.data?.address?.landmark,
               dial_code: res?.data?.data?.dial_code,
               street: res?.data?.data?.address?.street,
               name: res?.data?.data?.name,
               createdAt: res?.data?.data?.createdAt,
               profile_pic: res?.data?.data?.profile_pic
            })


         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,

            });
         }
      })
   }, [Token, id])



   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files;

      if (file && file.length !== 0) {
         setSelectedUser({ ...selectedUser, profile_pic: file[0] })
      }
      // setInputs({ ...inputs, service_image: file?. });

   }

   const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = event.target;

      setSelectedUser({ ...selectedUser, [name]: value });
   }
   const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      // console.log(formInput);
      event.preventDefault();
      const formData = new FormData();
      // console.log(inputs);
      dispatch(startLoading());

      formData.append('is_otp_verified', selectedUser?.is_otp_verified?.toString() ?? false);
      formData.append('is_user_details_completed', selectedUser?.is_user_details_completed?.toString() ?? false);
      formData.append('is_user_verified', selectedUser?.is_user_verified?.toString() ?? false);
      formData.append('country', selectedUser?.country ?? "");
      formData.append('state', selectedUser?.state ?? "");
      formData.append('city', selectedUser?.city ?? "");
      formData.append('lat', selectedUser?.lat?.toString() ?? 0);
      formData.append('long', selectedUser?.long?.toString() ?? 0);
      formData.append('pin_code', selectedUser?.pin_code ?? "");
      formData.append('street', selectedUser?.street ?? "");
      formData.append('landmark', selectedUser?.landmark ?? "");
      formData.append('phone', selectedUser?.phone ?? "");
      formData.append('name', selectedUser?.name ?? "");
      // console.log(selectedUser?.profile_pic)
      if (selectedUser.profile_pic) {
         // console.log("inside")
         formData.append('profile_pic', selectedUser.profile_pic);
      }
      if (!Token) return;
      // Add new food item

      postData(formData)

   }

   const postData = async (data: FormData) => {
      try {

         await axios.put(`${AppConfig.DEV_SERVER}/user-update/${selectedUser?._id}`, data, {
            headers: {

               'content-type': 'multipart/form-data',
               "X-Access-Token": Token
            },

         }).then((res) => {
            // console.log("res: ", res?.data)
            if (res?.data?.status_code !== 200) {
               // console.log("err")
               Swal.fire({
                  position: "center",
                  icon: "error",
                  title: 'Submission Failed',
                  text: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 1500
               });
               dispatch(stopLoading());

            }
            else {
               // console.log("success")
               setTimeout(() => {
                  dispatch(stopLoading());

                  Swal.fire({
                     position: "center",
                     icon: "success",
                     text: `${res?.data?.msg}`,
                     title: "Success!",
                     showConfirmButton: false,
                     timer: 1500
                  })
                  navigate(-1)
               }, 1000 * 2);

            }


         })

         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   };

   return (
      <MainLayout showAllFilters={true}>
         <div className=" main-div">

            <div className={`category-main me-2 p-3 p-md-4 card`} >

               <form onSubmit={handleFormSubmit} className="position-relative">
                  <div className="row">
                     <div className="col-6 mb-3">

                        <div className="inputs mb-2">
                           <div className=" d-flex flex-column align-items-start gap-2 ">
                              <label htmlFor="servicetitle">Name</label>
                              <input value={selectedUser?.name} onChange={handleChange} type="text" name="name" id="serviceTitle" aria-describedby="servicetitle" required />
                           </div>

                        </div>

                        <div className="inputs mb-2">
                           <div className="d-flex flex-column align-items-start gap-2 ">
                              <label htmlFor="phone">Phone</label>
                              <input value={selectedUser?.phone} onChange={handleChange} type="number" name="phone" id="phone" required />
                           </div>

                        </div>
                        <div className="inputs mb-2">
                           <div className="d-flex flex-column align-items-start gap-2">
                              <label htmlFor="profile_pic">Profile Pic</label>
                              <div className="d-flex align-items-center edit-image">
                                 <img
                                    src={
                                       selectedUser?.profile_pic
                                          ? typeof selectedUser.profile_pic === 'string'
                                             ? selectedUser.profile_pic
                                             : URL.createObjectURL(selectedUser.profile_pic)
                                          : profileIcon
                                    }
                                    alt="profile_pic"
                                 />
                                 <div className="edit-icon">
                                    <img src={edit} alt="edit-icon" />
                                    <input type="file" id="profile_pic" name="profile_pic" accept="image/png, image/jpeg, image/jpg"
                                       onChange={handleFileChange} />
                                 </div>

                              </div>


                           </div>
                        </div>
                        <div className="inputs mb-2">
                           <div className="d-flex flex-column align-items-start gap-2 ">
                              <label htmlFor="is_otp_verified">Is Otp Verified</label>
                              <div className="d-flex gap-4">

                                 <div className="d-flex gap-2">
                                    <Checkbox type={selectedUser?.is_otp_verified} id={"is_otp_verified"} name={"is_otp_verified"} onChange={(event) => setSelectedUser({ ...selectedUser, is_otp_verified: event.target.checked })} />
                                    <span>Verified</span>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div className="inputs mb-2">
                           <div className=" d-flex flex-column align-items-start gap-2">
                              <label htmlFor="is_user_verified">Is User Verified</label>

                              <div className="d-flex gap-2">
                                 <Checkbox type={selectedUser?.is_user_verified} id={"is_user_verified"} name={"is_user_verified"} onChange={(event) => setSelectedUser({ ...selectedUser, is_user_verified: event.target.checked })} />
                                 <span>Verified</span>
                              </div>

                           </div>
                        </div>
                        <div className="inputs mb-2 ">
                           <div className="d-flex flex-column align-items-start gap-2">
                              <label htmlFor="is_basic_details_completed">User Details Completed</label>
                              <div className="d-flex gap-4">

                                 <div className="d-flex gap-2">
                                    <Checkbox type={selectedUser?.is_user_details_completed} id={"is_user_details_completed"} name={"is_user_details_completed"} onChange={(event) => setSelectedUser({ ...selectedUser, is_user_details_completed: event.target.checked })} />
                                    <span>Completed</span>
                                 </div>
                              </div>
                           </div>
                        </div>

                     </div>
                     <div className="col-6">
                        <div className="row">
                           <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="country">Country</label>
                              <input value={selectedUser?.country} name="country" onChange={handleChange} id="country" required />
                           </div>
                           <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="state">State</label>
                              <input value={selectedUser?.state} name="state" onChange={handleChange} id="state" required />
                           </div>
                           <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="city">City</label>
                              <input value={selectedUser?.city} name="city" onChange={handleChange} id="city" required />
                           </div>
                           <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="pin_code">Pincode</label>
                              <input value={selectedUser?.pin_code} name="pin_code" onChange={handleChange} id="pin_code" required />
                           </div>
                           <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="lat">Latitude</label>
                              <input value={selectedUser?.lat} name="lat" onChange={handleChange} id="lat" required />
                           </div>
                           <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="long">Longitude</label>
                              <input value={selectedUser?.long} name="long" onChange={handleChange} id="long" required />
                           </div>

                           <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                              <label htmlFor="street">Street</label>
                              <input value={selectedUser?.street} name="street" onChange={handleChange} id="street" />
                           </div>
                           {
                              selectedUser?.landmark ? <div className="col-6 mb-2 d-flex flex-column align-items-start gap-2 inputs">
                                 <label htmlFor="landmark">Land Mark</label>
                                 <input value={selectedUser?.landmark} id="landmark" name="landmark" />
                              </div> : ""
                           }

                        </div>
                     </div>
                  </div>

                  {
                     loading ? <LoadingGif /> : ""
                  }


                  <div className="col-md-12 d-flex  align-items-center justify-content-between">
                     <button type="button" className="btn btn-dark" onClick={() => {
                        navigate(-1)
                     }}>Back</button>
                     <button type="submit" className="btn btn-primary">
                        {loading ? "Loading..." : "Update"}
                     </button>

                  </div>

               </form>
            </div>
         </div>
      </MainLayout>
   )
}

export default UserEditPage;